import { useEffect, useRef } from "react";

export const useCustomEventTrigger = ({
  enabled,
  timeout,
  triggerChat,
  eventName,
  triggerSource,
}) => {
  const hasTimeoutStarted = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const listener = () => {
      if (hasTimeoutStarted.current) return;
      hasTimeoutStarted.current = true;
      setTimeout(() => {
        triggerChat(triggerSource);
      }, timeout * 1000);
    };

    document.addEventListener(eventName, listener);

    return () => {
      document.removeEventListener(eventName, listener);
    };
  }, [enabled, timeout, triggerChat, eventName, triggerSource]);
};
